interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ index, eyebrow, title, desc }: SectionHeadingProps) {
  return (
    <div>
      <div className="flex items-center gap-3 text-[11px] tracking-[0.28em] text-foreground-500">
        <span className="font-label text-accent-600">{index}</span>
        <span className="h-px w-8 bg-foreground-900/20" />
        <span className="font-label uppercase">{eyebrow}</span>
      </div>
      <h3 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h3>
      {desc ? (
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
      ) : null}
    </div>
  );
}